import { skipToken } from "@reduxjs/toolkit/query";
import type { TrainingParticipantChapterAssessment } from "@repo/app-types/entities/trainingParticipant";
import { Size } from "@repo/ui/helpers/helpers";
import type { FC } from "react";
import { usePlaybookByIdQuery } from "../../api/entities/playbook.js";
import { useChapterPassRate } from "./chapterAssessmentHelpers.js";
import { TrainingAssessmentTemplateScorePill } from "./trainingAssessmentTemplateScorePill.js";

export interface ChapterAssessmentCellProps {
  assessment: TrainingParticipantChapterAssessment | undefined;
}

export const ChapterAssessmentCell: FC<ChapterAssessmentCellProps> = (
  props,
) => {
  const playbookId =
    props.assessment?.assessment_template?.recording_assessment_template_id;
  const assessmentTemplateCriteriaGrading =
    props.assessment?.assessment_template?.criteria_grading;
  const { data: playbook, isLoading: isLoadingPlaybook } = usePlaybookByIdQuery(
    playbookId ?? skipToken,
  );

  const passRate = useChapterPassRate(
    playbook,
    assessmentTemplateCriteriaGrading,
  );

  if (!props.assessment) {
    return null;
  }

  return (
    <>
      {assessmentTemplateCriteriaGrading ? (
        <TrainingAssessmentTemplateScorePill
          size={Size.SMALL}
          score={passRate}
          isLoading={isLoadingPlaybook}
        />
      ) : null}
    </>
  );
};
